import { Route, Routes } from 'react-router-dom';
import TopicListPage from './list';

export default function TopicRouting() {
  return (
    <Routes>
      <Route index element={<TopicListPage />} />
    </Routes>
  );
}
